export default "__VITE_ASSET__DMGMPT_f__"